export default "__VITE_ASSET__BUoSxbLC__"